import { Editor, Element, Text } from 'slate';

import { AI_TOOL, BLOCK_TYPES } from 'bundles/cml/shared/constants';

import _t from 'i18n!nls/cml';

export const hasAILayoutElement = (editor: Editor): boolean => {
  return editor.children.some(
    (el) => Element.isElement(el) && el.type === BLOCK_TYPES.AI_ELEMENT && el.aiTool === AI_TOOL.LAYOUT
  );
};

export const getWordCount = (editor: Editor) => {
  const textNodes = Array.from(
    Editor.nodes<Text>(editor, {
      at: { anchor: Editor.start(editor, [0]), focus: Editor.end(editor, [editor.children.length - 1]) },
      match: (node) => Text.isText(node),
    })
  );

  const allText = textNodes.map(([{ text }]) => text).join('');
  const words = Array.from(new Intl.Segmenter(_t.getLocale(), { granularity: 'word' }).segment(allText));

  return words.length;
};
